// src/components/ClinicModeRoute.jsx
import { Box, Alert, CircularProgress } from '@mui/material';
import { useClinic } from '../context/ClinicContext';
import { useAuth } from '../context/AuthContext';

export default function ClinicModeRoute({ children }) {
  const { selectedClinicId, memberships } = useClinic();
  const { loading: authLoading, authStatus } = useAuth();

  // Mientras autenticación carga, no bloquear ni redirigir
  if (authLoading || authStatus === 'loading') {
    return (
      <Box sx={{ p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  // Si el usuario no pertenece a ninguna clínica
  if (!memberships || memberships.length === 0) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">
          No perteneces a ninguna clínica todavía. Crea o únete a una desde el botón "Crear clínica" o usando un enlace de invitación.
        </Alert>
      </Box>
    );
  }

  // Si hay membresías pero no hay clínica seleccionada
  if (!selectedClinicId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">
          Selecciona una clínica desde el selector en la barra superior para acceder a esta sección.
        </Alert>
      </Box>
    );
  }

  return children;
}
